module.exports = __webpack_public_path__ + "img/roll-dough.0a5de713.svg";